module.exports = __webpack_public_path__ + "img/banner.66da4bbd.png";